import React from "react";
import { MessageCircle } from "lucide-react";
import { COMPANY } from "@/lib/site";

export default function WhatsappFloat() {
  const text = encodeURIComponent(
    "Ciao MotorieRicambi, vorrei informazioni su un ricambio."
  );
  return (
    <a
      href={`https://wa.me/${COMPANY.whatsappRaw}?text=${text}`}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Scrivici su WhatsApp"
      data-testid="whatsapp-float"
      className="fixed bottom-6 right-6 z-50 group"
    >
      <span className="relative inline-flex w-14 h-14 items-center justify-center bg-[#25D366] hover:bg-[#1ebe5b] transition-colors wa-pulse">
        <MessageCircle size={26} className="text-white" />
      </span>
      <span className="absolute right-16 top-1/2 -translate-y-1/2 hidden md:block bg-[#0e0e0e] border border-white/10 px-3 py-2 text-xs uppercase tracking-widest text-white whitespace-nowrap opacity-0 group-hover:opacity-100 translate-x-2 group-hover:translate-x-0 transition-all duration-300">
        Scrivici su WhatsApp
      </span>
    </a>
  );
}
